import { Box, Typography, styled } from "@mui/material";

import { DefaultUrlWeb } from "config/Configuration";

export function SrcCoin({ data }) {
  return (
    <BoxSrcCoin className={"n-coin-section"}>
      <img
        width={"35"}
        src={DefaultUrlWeb + data?.coinSourceImageUrl}
        alt={""}
      />
      <Typography variant="h6" color="text.main" fontWeight={400}>
        {data.coinSourceName}{" "}
        <Typography
          component="small"
          color="secondary.text"
          variant="subtitle2"
        >
          /{data.coinDestinationName}
        </Typography>
      </Typography>
    </BoxSrcCoin>
  );
}

const BoxSrcCoin = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  img: {
    marginRight: theme.spacing(1.25),
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    backgroundColor: theme.palette.text.main,
  },
  h6: {
    small: {
      opacity: 0.7,
    },
  },
}));

export default SrcCoin;
